export enum EnumOrigemEmissao {
    PROPRIO = 0,
    TERCEIROS = 1,
}